type QueryShorthandContext = {
	currentSpaceKey?: string;
	currentContentId?: string;
};

// Matches both bare and quoted variants of the supported sentinels
// (`currentSpace()` / `currentContent()`), tolerating optional whitespace
// before and inside the parentheses (e.g. `currentSpace ( )`). Some macro
// authors / older clients persist `"currentSpace()"` as a string literal, so
// we accept both forms. The sentinel name is captured so the resolver can
// look up the corresponding substitution value.
const SHORTHAND_REGEX = /"?(currentSpace|currentContent)\s*\(\s*\)"?/g;

export const resolveQueryShorthands = (
	rawCql: string,
	{ currentSpaceKey, currentContentId }: QueryShorthandContext,
): string => {
	if (!rawCql) {
		return rawCql;
	}

	return rawCql.replace(SHORTHAND_REGEX, (match, sentinel: string) => {
		switch (sentinel) {
			case 'currentSpace':
				return currentSpaceKey == undefined ? match : `"${currentSpaceKey}"`;
			case 'currentContent':
				return currentContentId == undefined ? match : `"${currentContentId}"`;
			default:
				return match;
		}
	});
};
